import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d1fd0be"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_layout",
  src: "/assets/icon/ofertas.svg"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Consulte as ofertas disponíveis ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Caso queira adicionar ao seu carrinho, clique na oferta desejada ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ion-text-center b4" }, [
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("*alguns descontos somente para loja física")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "b5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon_layout",
    src: "/assets/icon/ofertas.svg"
  })
], -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Ofertas da Semana ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Nenhuma oferta encontrada ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_SafeArea = _resolveComponent("SafeArea")!
  const _component_Produto = _resolveComponent("Produto")!
  const _component_FooterMenu = _resolveComponent("FooterMenu")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.isOpenAtivacao,
        "initial-breakpoint": 0.60,
        breakpoints: [0, 0.65]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper, {
                pagination: true,
                modules: _ctx.modules,
                autoplay: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_swiper_slide, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center b1",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center b2",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center b3",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3,
                              _hoisted_4,
                              _hoisted_5
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modules"]),
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_SafeArea, {
        onOnBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.voltar())),
        data: {'cart': false}
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                class: "ion-text-center font-montserrat font-30 layout_blue"
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center bg_white" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ofertas, (produto, index) => {
                    return (_openBlock(), _createBlock(_component_ion_col, {
                      class: "produto ion-text-center divider-right",
                      size: "6",
                      key: 'c'+index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Produto, { produto: produto }, null, 8, ["produto"]),
                        _hoisted_9
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.ofertas.length==0)
            ? (_openBlock(), _createBlock(_component_ion_row, {
                key: 0,
                class: "ion-align-items-center bg_white"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_FooterMenu, { data: {inicial:false} })
    ]),
    _: 1
  }))
}